// The values are saved in the `tab` query param and the page filter, so renaming one breaks restored links
export enum AccidentsIncidentsTab {
  // AccidentAlerts = 'accident-alerts',
  DetectedAccident = 'detected-accident',
  IncidentReport = 'incident-report'
}

export const AccidentsIncidentsTabLabelKeys: Record<AccidentsIncidentsTab, string> = {
  // [AccidentsIncidentsTab.AccidentAlerts]: 'accidents.tabs.accidentAlerts',
  [AccidentsIncidentsTab.DetectedAccident]: 'accidents.tabs.detectedAccident',
  [AccidentsIncidentsTab.IncidentReport]: 'accidents.tabs.incidentReport'
};
